import { render, staticRenderFns } from "./GoodViewer.vue?vue&type=template&id=b36226aa&"
import script from "./GoodViewer.vue?vue&type=script&lang=ts&"
export * from "./GoodViewer.vue?vue&type=script&lang=ts&"
import style0 from "./GoodViewer.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports